import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Surface } from '../surface/Surface';
import { ExtraInformationInterface } from './ExtraInformation.interface';
import { Info } from '../icon/icons/Info';
import { Html } from '../html/Html';
import tokens from './tokens';

const StyledSurface = styled(Surface)`
  ${({ theme: { space, colors } }) => css`
    display: flex;
    flex-direction: ${tokens.flexDirection};
    gap: ${space.xSmall};
    margin-top: ${space.fluidSmall};
    ${tokens.borderColor &&
    css`
      border: 1px solid ${colors[tokens.borderColor]};
    `}
  `};
`;

const StyledHtmlContainer = styled.div`
  > div {
    display: ${tokens.display};
    flex-direction: column;
    justify-content: center;
    margin-left: initial;
  }
`;

const StyledInfo = styled(Info)`
  ${({ theme: { space, colors } }) => css`
    width: ${space.medium};
    height: ${space.medium};
  `};
`;

const ExtraInformation: FC<ExtraInformationInterface> = ({ text, padding }) => (
  <StyledSurface
    backgroundColor={tokens.backgroundColor}
    padding={padding || tokens.padding}
  >
    <StyledInfo aria-hidden="true" />
    <StyledHtmlContainer>
      <Html small={tokens.smallText}>{text}</Html>
    </StyledHtmlContainer>
  </StyledSurface>
);

export { ExtraInformation };
